import { render, staticRenderFns } from "./CallOrder.vue?vue&type=template&id=5d0d1e32&"
import script from "./CallOrder.vue?vue&type=script&lang=js&"
export * from "./CallOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports